// extracted by mini-css-extract-plugin
export default {"head_search_filter":"MainSection_head_search_filter__St+uZ","country_cards":"MainSection_country_cards__s1zbu"};